import buildRequest from '../buildRequest';

// Endpoints
import { typesEndpoint } from '../../../common/types';

// Libs
import { axios } from '../../../lib/axios';

// Utils
import { dataResponse, handleError } from '../../../utils';

export const apiCrearBitacora = async params => {
  const url = typesEndpoint.crearBitacora;

  const request = {
    ...params,
  };

  try {
    const { status, data } = await axios.post(url, request, buildRequest());

    return dataResponse({ data: data.data, statusCode: status });
  } catch (error) {
    return handleError(error);
  }
};
